import React, { PureComponent } from "react";
import { Modal, Button } from "react-bootstrap";
import AddIssueForm from "./AddIssueForm";
import { get } from "lodash";
import {
  editDataOfAddIssue,
  GROUP_KEYS,
  isValidArray,
  modifyDataOfAddIssue
} from "../../helper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getIssueList, clearIssueList } from "../../actions/common.action";
import {
  updateIssueAction,
  isIssueDuplicatedAction
} from "../../actions/issues.action";
import { getIssueDetails } from "../../actions/issueDetail.action";
import { toast } from "react-toastify";
import { ERROR_MSG, STATUS } from "../../constant";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { withRouter } from "react-router-dom";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { LoaderPage } from "../../component/Loader";

export class EditIssue extends PureComponent {
  state = {
    issueFormSubmittedOnce: false,
    showLanguageError: true,
    loaderdisplay: true
  };
  isApiLoaded = false;

  async componentDidMount() {
    const { issueId, getIssueDetailsDispatch } = this.props;
    if (issueId) {
      const resp = await getIssueDetailsDispatch(undefined, {
        issueId
      });
      if (resp) {
        this.setState({
          issueData: resp,
          loaderdisplay: false
        });
      }
    }
  }

  updateParentState = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  updateParentStateError = (key, value) => {
    this.setState(prevState => {
      return {
        error: {
          ...prevState.error,
          [key]: value
        }
      };
    });
  };

  resetAddIssue = value => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        issueCOListError: value,
        issuesError: value
      }
    }));
  };

  onValidateForm = async () => {
    console.log("from edit issue");
    const errorObj = { ...this.state.error };
    const { issueData, issueFormSubmittedOnce } = this.state;
    this.setState({ showLanguageError: false });
    let invalidForm;
    if (!isValidArray(get(errorObj, "issueCOListError"))) {
      toast.error(
        <p className="toast-text-alignment">At least one issue is required.</p>,
        errorToastStyle
      );
      return;
    }
    errorObj["issuesError"] = get(errorObj, "issueCOListError", []).map(
      value => {
        if (value.error) {
          invalidForm = true;
        }
        return value;
      }
    );

    if (!invalidForm) {
      const { issueData } = this.state;
      const projectData = get(issueData, "data.projectIssueDTO");
      let isProjectAwardedByState = !get(issueData, "data.allowCentralToEdit");
      const modifyData = modifyDataOfAddIssue(
        this.state,
        isProjectAwardedByState
      );
      const issue = modifyData[0];
      const duplicatedIssueResp = await isIssueDuplicatedAction(undefined, {
        issueCategoryId: get(issue, "issueCategoryId"),
        projectId: get(issueData, "data.projectIssueDTO.id"),
        issueId: get(issueData, "data.id"),
        issueSubCategoryId: get(issue, "issueSubCategoryId"),
        recipientGroup: get(issue, "recipientGroup"),
        title: get(issue, "title")
      });

      if (get(duplicatedIssueResp, "data")) {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DUPLICATED_ISSUES_IN_PROJECT}
          </p>,
          errorToastStyle
        );
      } else {
        this.openConfirmationAlert();
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
      this.setState({
        error: errorObj,
        issueFormSubmittedOnce: true
      });
    }
  };

  onRemoveFile = async () => {
    const { initialRequiredFields } = this.state;

    this.setState({
      error: {
        issueCOListError: [
          {
            error: false
            //required_field: initialRequiredFields
          }
        ],
        issuesError: [
          {
            error: false
            //required_field: initialRequiredFields
          }
        ]
      }
    });
  };

  onSubmit = async () => {
    const { updateIssueDispatch, handleClose, callApiOnSuccess } = this.props;
    const { issueData, issueCOList } = this.state;
    this.setState({ isApiLoading: STATUS.LOADING });
    try {
      const projectData = get(issueData, "data.projectIssueDTO");
      let isProjectAwardedByState = !get(issueData, "data.allowCentralToEdit");
      const modifyData = modifyDataOfAddIssue(
        this.state,
        isProjectAwardedByState
      );
      modifyData[0]["projectId"] = get(issueData, "data.projectId");
      modifyData[0]["secondaryStateId"] =
        issueCOList && issueCOList[0].secondaryStateId;
      modifyData[0]["secondaryStateDepartmentId"] =
        issueCOList && issueCOList[0].secondaryStateDepartmentId;
      modifyData[0]["secondaryMinistryId"] =
        issueCOList && issueCOList[0].secondaryMinistryId;
      modifyData[0]["secondaryMinistryDepartmentId"] =
        issueCOList && issueCOList[0].secondaryMinistryDepartmentId;
      const response = await updateIssueDispatch(
        undefined,
        modifyData[0],
        get(issueData, "data.id")
      );
      if (response) {
        const { message, status } = response;
        handleClose();
        (status &&
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        typeof callApiOnSuccess === "function" && callApiOnSuccess();
        this.setState({
          isApiLoading: (status && STATUS.SUCCESS) || STATUS.ERROR
        });
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert
    }));
  };

  onMouseclick = () => {
    window.addEventListener("keyup", event => {
      this.setState({
        showLanguageError: true
      });
    });
  };

  render() {
    const {
      show,
      handleClose,
      projectPPList,
      workflowType,
      projectData,
      isProposalValidated
    } = this.props;
    const {
      resetForm,
      showAlert,
      error,
      isApiLoading,
      issueData,
      issueFormSubmittedOnce,
      showLanguageError
    } = this.state;
    return (
      <React.Fragment>
        {!isValidArray(issueData) && (
          <LoaderPage
            loading={this.state.loaderdisplay || isProposalValidated}
          />
        )}
        {this.state.showLanguageError === false && this.onMouseclick()}
        {issueData !== undefined && issueData !== null && (
          <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            className="edit-issue"
          >
            <ConfirmationComponent
              show={showAlert}
              isLoading={isApiLoading}
              modalClass={"confirmation-modal"}
              saveHandler={this.onSubmit}
              closeHandler={this.openConfirmationAlert}
            />
            <Modal.Header closeButton />
            <Modal.Body className="edit-issue-model">
              {(get(issueData, "status") && (
                <AddIssueForm
                  showLanguageError={showLanguageError}
                  //title="Add Issue"
                  onValidateForm={this.onValidateForm}
                  handleProposalChange={this.props.handleProposalChange}
                  params={{
                    // stateId:
                    //   get(
                    //     get(issueData, "data"),
                    //     "projectIssueDTO.sponsoredByCategory"
                    //   ) === GROUP_KEYS.STATE &&
                    //   get(
                    //     get(issueData, "data"),
                    //     "projectIssueDTO.sponsoredByid"
                    //   ),

                    show: get(issueData, "data.displayAutocomplete"),
                    issueDetails: editDataOfAddIssue({
                      issueCOList: [get(issueData, "data")]
                    }),
                    resetForm: resetForm,
                    error:
                      issueFormSubmittedOnce &&
                      get(error, "issueCOListError", {}),
                    updateParentState: this.updateParentState,
                    updateParentStateError: this.updateParentStateError,
                    resetIssue: this.resetAddIssue,
                    isEdit: true,
                    allowOnEdit: get(issueData, "data.allowOnEdit"),
                    childIssue: get(issueData, "data.childIssue"),
                    issueFormType: get(issueData, "data.issueFormType"),
                    isProjectAwardedByState: !get(
                      issueData,
                      "data.allowCentralToEdit"
                    ),
                    /*   get(
                      issueData,
                      "data.projectIssueDTO.sponsoredByCategory"
                    ) === GROUP_KEYS.STATE,*/
                    parentGroupId: !get(issueData, "data.childIssue")
                      ? get(
                          issueData,
                          "data.projectIssueDTO.sponsoredByid",
                          null
                        )
                      : get(issueData, "data.recipientGroupParentId"),
                    selectedOptionImageUrl: get(
                      issueData,
                      "data.projectIssueDTO.sponsoredByImageUrl"
                    ),
                    workflowType: workflowType,
                    projectPPList: projectPPList,
                    projectID: get(projectData, "data.id", null),
                    createdBy: issueData.data.previousCreatedBy,
                    issueData: issueData
                  }}
                  onRemoveFileDetail={this.onRemoveFile}
                />
              )) ||
                null}
            </Modal.Body>
            {/* <Button onClick={this.onValidateForm} className="issue-submit">
            {" "}
            Submit{" "}
          </Button> */}
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueData: state.issueDetailsReducer.issueData,
    projectData: state.projectDetailsReducer.projectData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getIssueDetailsDispatch: getIssueDetails,
      updateIssueDispatch: updateIssueAction,
      clearIssueDetailsDispatch: clearIssueList,
      getIssueListDispatch: getIssueList
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditIssue)
);
